<template>
  <div>
    <div
      v-for="index in count"
      :key="index"
      class="job-skeleton"
    >
      <span class="job-skeleton__line job-skeleton__line--pill" />
      <span class="job-skeleton__line job-skeleton__line--title" />
      <span class="job-skeleton__line job-skeleton__line--path" />
      <div class="job-skeleton__meta">
        <span class="job-skeleton__line job-skeleton__line--meta" />
        <span class="job-skeleton__line job-skeleton__line--meta" />
        <span class="job-skeleton__line job-skeleton__line--meta" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobMobileCardSkeleton',
  props: {
    count: {
      type: Number,
      default: 4,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.job-skeleton {
  margin-bottom: 12px;
  padding: 14px;
  border: 1px solid $gray-1234;
  border-radius: 8px;
  background-color: $white;

  &__line {
    display: block;
    height: 12px;
    border-radius: 4px;
    background: linear-gradient(90deg, $gray-100 25%, $gray-50 37%, $gray-100 63%);
    background-size: 400% 100%;
    animation: job-skeleton-shimmer 1.3s ease-in-out infinite;

    &--pill {
      width: 88px;
      height: 20px;
      border-radius: 20px;
    }
    &--title {
      width: 70%;
      height: 16px;
      margin-top: 12px;
    }
    &--path {
      width: 45%;
      height: 10px;
      margin-top: 8px;
    }
    &--meta {
      width: 100%;
      height: 24px;
    }
  }

  &__meta {
    display: flex;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid $gray-1234;

    .job-skeleton__line--meta {
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

@keyframes job-skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .job-skeleton__line {
    animation: none;
  }
}
</style>
